import Box from '@mui/material/Box';

export const Map = () => {
    return (
        <Box
            sx={{
                width: '100%',
                height: {
                    xs: 300,  // Mobile
                    sm: 400,  // Small tablets
                    md: 450,  // Desktops
                },
                display: 'flex',
            }}
        >
            <iframe
                title="Google Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0170568646736!2d175.29607387660027!3d-37.78964003266095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d6d19928ef767f3%3A0xf9afd93423e775cf!2se-smartwash%20laundromat!5e0!3m2!1sen!2sin!4v1744628474717!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
            ></iframe>
        </Box>
    );
};